export function getInterCom() {
    if (typeof window !== "undefined") {
        return (window as any).Intercom;
    }
}

export function getInterComSettings(): any {
    if (typeof window !== "undefined") {
        return (window as any).intercomSettings !== undefined && (window as any).intercomSettings;
    }
}

export function useDefaultIntercom(appId: string, intercom: any) {
    if (intercom) {
        intercom('shutdown'); // Reset intercom so it clears the cookie

        intercom("boot", {
            app_id: appId,
            custom_launcher_selector: '.intercom-trigger',
            hide_default_launcher: true
        });
    }
}

export function getIntercomData(email: string, intercomHash: string, appId: string, intercom: any) {
    if (intercom) {
        if (email && intercomHash) {
            intercom("boot", {
                app_id: appId,
                email,
                user_hash: intercomHash,
                custom_launcher_selector: '.intercom-trigger',
                hide_default_launcher: true
            });

        } else {
            useDefaultIntercom(appId, intercom) // Fallback to anonymous intercom                                                               
        }
    }
}